import React from 'react';
import AppMenu from './components/AppMenu';
import './css/Home.css';

function Home() {
  return (
    <div className="container">
      <AppMenu />
      <main className="main">
        <div className="home-content">
          <h2>TurboSME Solutions</h2>
          <p>We provide innovative solutions for small and medium enterprises.</p>
          <p>Our services include:</p>
          <ul>
            <li>Business Consulting</li>
            <li>Digital Transformation</li>
            <li>Financial Planning</li>
          </ul>
        </div>
      </main>
    </div>
  );
}

export default Home;
